import React from 'react';
import LirInfo from '../../../../../components/Forms/lir/info';

function PMELIRInfo() {
	return <LirInfo module="pme"  />;
}
export default PMELIRInfo;

